import React from 'react';
import { Briefcase, MapPin, Calendar } from 'lucide-react';

const ExperienceCard = ({ exp }) => {
  return (
    <article className="v2-exp-card">
      <header className="v2-exp-card-head">
        {exp.logo && (
          <div className="v2-exp-logo">
            <img
              src={exp.logo}
              alt={`${exp.company} logo`}
              width="32"
              height="32"
              loading="lazy"
              decoding="async"
            />
          </div>
        )}
        <div className="v2-exp-titles">
          <h3 className="v2-exp-role">{exp.role}</h3>
          <div className="v2-exp-company">{exp.company}</div>
          <div className="v2-exp-meta">
            <span className="v2-exp-meta-item">
              <Calendar size={13} aria-hidden="true" />
              {exp.period}
            </span>
            <span className="v2-exp-meta-item">
              <MapPin size={13} aria-hidden="true" />
              {exp.location}
            </span>
          </div>
        </div>
      </header>

      {exp.highlights?.length > 0 && (
        <ul className="v2-exp-highlights">
          {exp.highlights.map((h, idx) => (
            <li key={idx}>{h}</li>
          ))}
        </ul>
      )}
    </article>
  );
};

const Experience = ({ data }) => {
  return (
    <section id="experience" className="section-container v2-exp-section">
      <div className="content-wrapper">
        <div className="section-header">
          <div className="section-label">
            <Briefcase size={18} />
            <span>Experience</span>
          </div>
        </div>

        <div className="v2-exp-list">
          {data.map((exp) => (
            <ExperienceCard key={exp.id} exp={exp} />
          ))}
        </div>
      </div>
    </section>
  );
};

export default Experience;
